module.exports = __webpack_public_path__ + "static/img/howto-explain01.fd585da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/howto/howto-explain01.png
// module id = pAR+
// module chunks = 1